import React, { useState } from "react";
import sensors from "../../data/sensorsData";
import PriceModal from "../../components/PriceModal";
import DatasheetModal from "../../components/DatasheetModal";  // ✅ import
import "./LevelPage.css";

function LevelPage() {
  const [selectedSensor, setSelectedSensor] = useState(null);
  const [datasheetSensor, setDatasheetSensor] = useState(null);

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">Level Sensors</h2>
      <div className="row">
        {sensors.map((sensor) => (
          <div className="col-md-4 mb-4" key={sensor.id}>
            <div className="card sensor-card">
              <img
                src={sensor.image}
                className="card-img-top"
                alt={sensor.name}
              />
              <div className="card-body">
                <h5 className="card-title">{sensor.name}</h5>
                <p className="card-text">{sensor.description}</p>

                {/* Buttons Row */}
                <div className="d-flex justify-content-between">
                  {/* Left: View Price */}
                  <button
                    className="btn btn-sm btn-success"
                    onClick={() => setSelectedSensor(sensor)}
                  >
                    View Price
                  </button>

                  {/* Right: View PDF */}
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => setDatasheetSensor(sensor)}
                  >
                    View Datasheet
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Price Modal */}
      {selectedSensor && (
        <PriceModal
          sensor={selectedSensor}
          onClose={() => setSelectedSensor(null)}
        />
      )}

      {/* Datasheet Modal */}
      {datasheetSensor && (
        <DatasheetModal
          sensor={datasheetSensor}
          onClose={() => setDatasheetSensor(null)}
        />
      )}
    </div>
  );
}

export default LevelPage;
